<script lang="ts">
	import Picture from '$lib/components/atoms/image/Picture.svelte';
	import ModalDialog from '$lib/components/modals/ModalDialog.svelte';
	import { marketingEvent } from '$lib/constants/marketingModal';
	import { showElementAfterDidomiModal } from '$lib/services/tracking/didomi/consent';
	import { marketingModalActions, trackMarketingModal } from '$lib/services/tracking/googleAnalytics/marketingModal';
	import { getSearchParamsStore } from '$lib/services/urls/searchParams';
	import { useMarketingEvent } from '$lib/utils/marketingEvent.svelte';
	import { onMount } from 'svelte';

	// NOTE: for now we start with a simple modal with a picture component, but if we need
	// to add more (different) content, this might be a great use case for createRawSnippet: https://svelte.dev/docs/svelte/svelte#createRawSnippet

	const { maxNbOpening, redirectTo, pictureProps } = marketingEvent;

	let modalIsOpen = $state(false);
	const { setUserHasParticipated, setUserHasViewedModalOneTime, getCurrentOpeningNumber } = useMarketingEvent();
	const searchParams = getSearchParamsStore();

	function openModal() {
		const isDidomiVisible = window.Didomi?.notice?.isVisible();
		const isAuthenticationPage = window.location.pathname.includes('authentication'); // to prevent modal from showing on authentication page

		if (isDidomiVisible || Boolean($searchParams?.showModal) || getCurrentOpeningNumber() >= maxNbOpening || isAuthenticationPage) {
			if (isDidomiVisible) {
				showElementAfterDidomiModal(openModal);
			}
			return;
		}

		modalIsOpen = true;
		trackMarketingModal(marketingModalActions.display, getCurrentOpeningNumber());
	}

	function closeButtonCallback() {
		trackMarketingModal(marketingModalActions.close, getCurrentOpeningNumber());
		setUserHasParticipated();
	}

	function closeCallback() {
		modalIsOpen = false;
	}

	function clickOutsideCallback() {
		trackMarketingModal(marketingModalActions.close, getCurrentOpeningNumber());
		setUserHasViewedModalOneTime();
		modalIsOpen = false;
	}

	function onClickCallback() {
		trackMarketingModal(marketingModalActions.click, getCurrentOpeningNumber());
		setUserHasViewedModalOneTime();
		closeCallback();
	}

	onMount(() => {
		openModal();
	});
</script>

<ModalDialog
	bind:open={modalIsOpen}
	{closeCallback}
	{closeButtonCallback}
	{clickOutsideCallback}
	closeText=""
	class="w-full h-full"
	paneClasses="p-0 w-full h-full md:flex md:justify-center md:items-center"
	contentDialogClasses="p-0 w-full h-full p-2 md:max-w-[500px] md:mx-auto md:h-auto md:w-auto"
>
	<a
		href={redirectTo}
		onclick={onClickCallback}
		class="marketing-modal-link flex flex-nowrap justify-center w-full"
	>
		<Picture {...pictureProps} class="m-auto md:w-full md:h-[471px] object-cover" eager />
	</a>
</ModalDialog>

<style>
	.marketing-modal-link :global(img) {
		image-rendering: pixelated;
		image-rendering: -moz-crisp-edges;
		image-rendering: -webkit-optimize-contrast;
	}
</style>
